export default __webpack_public_path__ + "static/media/race_information_icon.b8cca61b.svg";